import {isNotEmpty, isNotNil} from 'ramda';

import {getSafely} from 'shared/web';

import {FilterFormData} from '../types/FilterFormData';

export const simpleFilterKeys: (keyof FilterFormData)[] = [
  'radius',
  'title',
  'showSoldIn30',
  'showSoldIn90',
  'showStockCars',
  'priceGte',
  'priceLte',
  'isVatDeductible',
  'firstRegistrationOnYearGte',
  'firstRegistrationOnYearLte',
  'powerGte',
  'powerLte',
  'mileageGte',
  'mileageLte',
  'daysInAdvertisementGte',
  'daysInAdvertisementLte',
  'featureScoreGte',
  'featureScoreLte',
  'drive',
  'transmission',
  'bodyStyle',
  'fuelType',
  'trimLevels',
  'sellerType',
];

export const parseFilterFormDataToSearchParams = (
  currentSearchParams: URLSearchParams,
  filterFormData: FilterFormData | null
): URLSearchParams => {
  const params = new URLSearchParams(currentSearchParams);
  if (isNotNil(filterFormData?.address) && isNotEmpty(filterFormData.address)) {
    params.set('label', filterFormData.address.label);
    params.set('lat', filterFormData.address.lat.toString());
    params.set('lng', filterFormData.address.lng.toString());
  } else {
    params.delete('label');
    params.delete('lat');
    params.delete('lng');
  }
  simpleFilterKeys.forEach((key) => {
    const newValue = getSafely(filterFormData, key);
    if (isNotNil(newValue) && isNotEmpty(newValue)) {
      params.set(key, newValue.toString());
    } else {
      params.delete(key);
    }
  });
  return params;
};
